import React from "react";
import { ShareSvg } from "assets/icons/ShareSvg";

const EmptyShare = ({ emptyText }) => {
  return (
    <div className="text-center d-flex flex-column align-items-center my-5">
      <ShareSvg />
      <small className="my-1">{emptyText}</small>
    </div>
  );
};

export default EmptyShare;
